import React from 'react'

import styles from './styles.module.scss'

export const Article: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <article className={styles.article}>{children}</article>
}
